import { THEME_VARIANTS } from '../theme-variant';

const svgUrl = (svg) => `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;

// Reskin: quote's toggle (Branch Design System): a 48×24 pill with an 18px thumb that shows ✕ when off and ✓ when on.
const reskinSwitch = (theme) => {
  const { beige_25, beige_60, beige_75, beige_50, orange_75 } = theme.colorPalette;
  const cross = svgUrl(
    `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="${beige_75}" stroke-width="1.5" stroke-linecap="round"><path d="M12.7 5.3 5.3 12.7M5.3 5.3l7.4 7.4"/></svg>`
  );
  const check = svgUrl(
    `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="${beige_25}" stroke-width="1.5" stroke-linecap="round"><path d="M5.625 8.929 7.922 11.25 12.375 6.75"/></svg>`
  );
  const colors = {
    color: beige_25,
    '&$checked': { color: orange_75 },
    '&$checked + $track': { backgroundColor: theme.colors.selection_control, opacity: 1 }
  };
  return {
    root: { width: 48, height: 24, padding: 0, margin: theme.spacing(0, 2, 0, 0), overflow: 'visible' },
    switchBase: {
      padding: 3,
      '&&:hover': { backgroundColor: beige_50 },
      '&$checked': { transform: 'translateX(24px)' },
      '&$checked $thumb': { backgroundImage: check },
      '&$disabled': { opacity: 0.5 },
      '&$disabled + $track': { opacity: 0.5 }
    },
    thumb: {
      width: 18,
      height: 18,
      boxShadow: '0 2.4px 2.4px rgba(0, 0, 0, 0.2)',
      backgroundImage: cross,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },
    track: { borderRadius: 60, backgroundColor: beige_60, opacity: 1 },
    colorPrimary: colors,
    colorSecondary: colors
  };
};

const overrideSwitch = (theme) => {
  if (theme.themeVariant === THEME_VARIANTS.RESKIN) {
    theme.overrides.MuiSwitch = reskinSwitch(theme);
    return;
  }
  theme.overrides.MuiSwitch = {
    root: {
      marginLeft: -14
    },
    colorPrimary: {
      color: theme.colorPalette.beige_50,
      '&$checked': {
        color: theme.colorPalette.orange_50
      }
    },
    colorSecondary: {
      height: 'auto',
      color: theme.colorPalette.green_80
    },
    disabled: {
      color: theme.colorPalette.orange_50_op_70
    }
  };
};

export default overrideSwitch;
